<div class="capital-maintence-view">
    <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
        <div class="uitk-c-card uhc-font">
            <div class="uitk_new_header">
                <div class="uitk-l-grid__col--12 stk-container-tabl-header">
                    <div class="col-8 mb-3">
                        <mat-tab-group [hidden]="normalUser" [selectedIndex]="getSelectedTabIndex()" (selectedTabChange)="selectionTypeChange($event)"  aria-label="ot labor proposal Tabs" role="tablist">
                            <mat-tab *ngFor="let tab of tabs" [label]="tab.label"  role="tab"></mat-tab>
                        </mat-tab-group>
                        <div>
                            <label *ngIf="normalUser" class="mdc-label myReqFontSize">My Requests</label>
                        </div>
                    </div>
                    <app-my-prop-requests *ngIf="selectedOption === 'requests'"></app-my-prop-requests>
                    <app-my-prop-approvals *ngIf="selectedOption === 'approvals'" [isUCMGOwner]="isUCMGOwner"></app-my-prop-approvals>
                </div>
            </div>
        </div>
    </div>
</div>